export default {
  name: 'Nama',
  tel: 'Telepon',
  save: 'Simpan',
  confirm: 'Konfirmasi',
  cancel: 'Batal',
  delete: 'Hapus',
  complete: 'Selesai',
  loading: 'Memuat...',
  telEmpty: 'Silahkan isi nomor telepon',
  nameEmpty: 'Silahkan isi nama',
  nameInvalid: 'Silahkan masukkan nama yang benar',
  confirmDelete: 'Yakin ingin menghapus?',
  telInvalid: 'Silahkan masukkan nomor handphone yang benar',
  vanCalendar: {
    end: 'Akhir',
    start: 'Mulai',
    title: 'Pilih Tanggal',
    confirm: 'Konfirmasi',
    startEnd: 'Mulai/Akhir',
    weekdays: ['Minggu', 'Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu'],
    monthTitle: function monthTitle(year, month) {
      return year + " Tahun " + month + " Bulan";
    },
    rangePrompt: function rangePrompt(maxRange) {
      return "Pilih tanggal tidak boleh melebihi " + maxRange + " hari";
    }
  },
  vanContactCard: {
    addText: 'Tambah Kontak'
  },
  vanContactList: {
    addText: 'Buat Kontak Baru'
  },
  vanPagination: {
    prev: 'Halaman Sebelumnya',
    next: 'Halaman Berikutnya'
  },
  vanPullRefresh: {
    pulling: 'Seret untuk refresh...',
    loosing: 'Lepaskan untuk refresh...'
  },
  vanSubmitBar: {
    label: 'Total:'
  },
  vanCoupon: {
    unlimited: 'Tidak Ada Batas Penggunaan',
    discount: function discount(_discount) {
      return _discount + "% Diskon";
    },
    condition: function condition(_condition) {
      return "Min. " + _condition + " Rupiah";
    }
  },
  vanCouponCell: {
    title: 'Kupon',
    tips: 'Tidak Ada Kupon',
    count: function count(_count) {
      return _count + " Kupon yang Dapat Digunakan";
    }
  },
  vanCouponList: {
    empty: 'Tidak Ada Kupon',
    exchange: 'Ganti',
    close: 'Tidak Gunakan Kupon',
    enable: 'Dapat Digunakan',
    disabled: 'Tidak Dapat Digunakan',
    placeholder: 'Masukkan Kode Kupon'
  },
  vanAddressEdit: {
    area: 'Wilayah',
    postal: 'Kode Pos',
    areaEmpty: 'Silahkan pilih wilayah',
    addressEmpty: 'Silahkan isi alamat lengkap',
    postalEmpty: 'Format kode pos tidak benar',
    defaultAddress: 'Tetapkan sebagai alamat pengiriman default',
    telPlaceholder: 'Nomor telepon penerima',
    namePlaceholder: 'Nama penerima',
    areaPlaceholder: 'Pilih Provinsi / Kota / Kecamatan'
  },
  vanAddressEditDetail: {
    label: 'Alamat Lengkap',
    placeholder: 'Nomor rumah, lantai, nomor kamar dll'
  },
  vanAddressList: {
    add: 'Tambah Alamat'
  }
};